/**
 * Default route shell — synchronously imported (not React.lazy) so Route.js can
 * render header/footer outside page Suspense once the app shell chunk has loaded.
 *
 * Other layouts are React.lazy in routes.js; each route still uses the same
 * layout assignment as before.
 */
import DefaultLayout from 'components/Application/components/layouts/DefaultLayout'

export { DefaultLayout }

export default DefaultLayout
